var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.99967 7.33333H3.06634C2.69297 7.33333 2.50629 7.33333 2.36368 7.406C2.23824 7.46993 2.13625 7.57187 2.07233 7.69733C1.99967 7.83993 1.99967 8.0266 1.99967 8.4V14M10.9997 7.33333H12.933C13.3064 7.33333 13.4931 7.33333 13.6357 7.406C13.7611 7.46993 13.8631 7.57187 13.927 7.69733C13.9997 7.83993 13.9997 8.0266 13.9997 8.4V14M10.9997 14V4.13333C10.9997 3.3866 10.9997 3.01323 10.8543 2.72801C10.7265 2.47713 10.5225 2.27315 10.2717 2.14533C9.98647 2 9.61307 2 8.86634 2H7.13301C6.38627 2 6.0129 2 5.72769 2.14533C5.4768 2.27315 5.27283 2.47713 5.145 2.72801C4.99967 3.01323 4.99967 3.3866 4.99967 4.13333V14M14.6663 14H1.33301M7.33301 4.66667H8.66634M7.33301 7.33333H8.66634M7.33301 10H8.66634",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.631f6e6d2793b4eb9fd566ebeac10e20.svg";
export { ForwardRef as ReactComponent };